import React from 'react'
import { Modal, QRCode } from 'antd'
import styled from '@emotion/styled'

import { IMG_STORAGE_URL } from '@src/utils/constants'
import SVGLoader from '@src/components/svg/SVGLoader'
import { CompanyInfo } from '../type'

type Props = {
	isCompanyPreviewModalOpened: boolean
	onCompanyPreviewModalCanceled: () => void
	companyInfo: CompanyInfo
}

export const CompanyPreviewModal: React.FC<Props> = ({
	isCompanyPreviewModalOpened,
	onCompanyPreviewModalCanceled,
	companyInfo,
}) => {
	return (
		<Modal
			open={isCompanyPreviewModalOpened}
			onCancel={onCompanyPreviewModalCanceled}
			title={<div style={{ height: '24px' }} />}
			footer={null}
			width={375}
			centered
			style={{ position: 'relative' }}
		>
			<CompanyChallengePreviewBodyContainer>
				<QRArea>
					<QRCode
						value={`https://${process.env.NODE_ENV !== 'production' ? 'qa.' : ''}motiners.com/${
							companyInfo.id
						}`}
						size={72}
						bordered={false}
						style={{ background: '#F7F7F7' }}
					/>
					<QRDescription>모바일로 보기</QRDescription>
				</QRArea>

				<CompanyInfoArea>
					<CompanyProfile>
						<CompanyImage
							src={`${IMG_STORAGE_URL}/commerce/vendor/profile_img/${companyInfo.profileImage}`}
						/>
						<CompanyName>{companyInfo.name}</CompanyName>
					</CompanyProfile>
					<CompanyDescription>{companyInfo.description}</CompanyDescription>
				</CompanyInfoArea>

				<ChallengeArea>
					<ChallengeHeader>
						<ChallengeTitle>핫딜 챌린지🔥</ChallengeTitle>
						<ChallengeMoreWrapper>
							<ChallengeMoreText>모두보기</ChallengeMoreText>
							<SVGLoader name="rightArrow" />
						</ChallengeMoreWrapper>
					</ChallengeHeader>
					<ChallengePositionInstruction>
						<ChallengePositionInstructionText>
							이 자리에 챌린지가 노출돼요!
						</ChallengePositionInstructionText>
					</ChallengePositionInstruction>
				</ChallengeArea>
			</CompanyChallengePreviewBodyContainer>
			<ContactTooltip>
				<ContactTooltipTitle>
					<TitleBold>
						생성한 챌린지를 노출시키고 싶다면,
						<br />
						문의 주세요
					</TitleBold>
					<TitleRegular>(평일 10:00~18:00까지)</TitleRegular>
				</ContactTooltipTitle>
				<ContactWrapper>
					<Contact>📞 : 010-9768-2105</Contact>
					<UrgentContact>📞 : (긴급 전화) 010-3454-4430</UrgentContact>
				</ContactWrapper>
			</ContactTooltip>
		</Modal>
	)
}

const CompanyChallengePreviewBodyContainer = styled.div`
	width: calc(100% + 48px);
	height: calc(80vh - 52px);
	overflow: scroll;
	-ms-overflow-style: none;
	scrollbar-width: none;
	&::-webkit-scrollbar {
		display: none;
	}
	margin-left: -24px;
	margin-bottom: -20px;
	border-bottom-left-radius: 8px;
	border-bottom-right-radius: 8px;
	display: flex;
	flex-direction: column;
`

const QRArea = styled.div`
	padding: 0 4px;
	display: flex;
	flex-direction: row;
	align-items: center;
	border-top: 1px solid #d9d9d9;
	background: #f7f7f7;
`

const QRDescription = styled.div`
	color: #121212;
	font-size: 16px;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
`

const CompanyInfoArea = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 16px;
	padding: 0 16px;
`

const CompanyProfile = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 12px;
`

const CompanyImage = styled.img`
	width: 63px;
	height: 63px;
	border-radius: 50%;
	overflow: hidden;
	object-fit: cover;
	border: 1px solid #c4c4c4;
`

const CompanyName = styled.div`
	color: #000;
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 22px;
`

const CompanyDescription = styled.div`
	color: #4e4e4e;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 150%;
	margin-top: 12px;
`

const ChallengeArea = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 45px;
`

const ChallengeHeader = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	padding: 0 16px;
`

const ChallengeTitle = styled.div`
	color: #121212;
	font-size: 20px;
	font-style: normal;
	font-weight: 600;
	line-height: 138%;
`

const ChallengeMoreWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 5px;

	& svg {
		color: #7f7f7f;
	}
`

const ChallengeMoreText = styled.div`
    color: #7F7F7F;
    font-size: 14px
    font-style: normal;
    font-weight: 600;
    line-height: 138%;
`

const ChallengePositionInstruction = styled.div`
	background: rgba(255, 107, 0, 0.09);
	border: 4.5px solid #d30000;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 163px;
	margin-top: 16px;
`

const ChallengePositionInstructionText = styled.div`
	color: #d30000;
	font-size: 18px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
`

const ContactTooltip = styled.div`
	position: absolute;
	background: #fff;
	top: 326px;
	left: 396px;
	padding: 0 18px;
	width: 302px;
	border-radius: 12px;

	&::after {
		content: ' ';
		position: absolute;
		top: 25%;
		left: -6px;
		border-width: 8px;
		border-style: solid;
		border-color: #ffffff;
		border-bottom-left-radius: 4px;
		transform: rotate(45deg);
	}
`

const ContactTooltipTitle = styled.div`
	margin-top: 16px;
`

const TitleBold = styled.span`
	color: #121212;
	font-size: 15px;
	font-style: normal;
	font-weight: 700;
	line-height: 150%;
`

const TitleRegular = styled.span`
	color: #121212;
	font-size: 15px;
	font-style: normal;
	font-weight: 400;
	line-height: 150%;
`

const ContactWrapper = styled.div`
	margin-top: 22px;
	margin-bottom: 24px;
`

const Contact = styled.div`
	color: #121212;
	font-size: 13px;
	font-style: normal;
	font-weight: 500;
	line-height: 150%;
`

const UrgentContact = styled.div`
	color: #910000;
	font-size: 13px;
	font-style: normal;
	font-weight: 500;
	line-height: 150%;
	margin-top: 10px;
`
